export const PROVISIONING = 'provisioning';
export const PROVISIONING_START = `${PROVISIONING}/start`;
